import "./_content.scss";

import {ReactNode} from "react";

function Content({children}: {children?: ReactNode}): JSX.Element {
  return <main className="content">{children}</main>;
}

export default Content;
